import React, { useEffect } from "react";

import ClientStats from "shared/util/ClientStats";
import _str from "shared/util/_str";
import Strf from "shared/components/Strf";
import Link from "shared/components/Link";
import Masthead from "../Masthead";
import BlueMask from "./blue_mask.svg";
import Badge from "./badge.svg";

import "./Incognito.scss";

const Incognito = React.forwardRef((_, ref) => {
	useEffect(() => { ClientStats.update("desktop - incognito - masthead - views"); }, []);

	return (
		<Masthead ref={ref} id="incognito_masthead" className="incognito-masthead" noClose>
			<div className="icons">
				<BlueMask className="icons-blue-mask" />
				<Badge className="icons-badge" />
			</div>
			<div className="incognito-masthead-text">
				<p>
					<Strf vars={{ incognitoMode: <strong>{_str("Incognito Mode")}</strong> }}>
						With $incognitoMode, you can hand-select who sees you on OkCupid.
						That means total control of your visibility.
					</Strf>
				</p>
			</div>
			<div>
				<Link to="/incognito" className="incognito-masthead-learnmore">
					{_str("Learn more")}
				</Link>
			</div>
		</Masthead>
	);
});

export default Incognito;



// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/Incognito/Incognito.jsx